"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const associatedComponents_1 = require("@/store/ducks/associatedComponents");
const selectors_1 = require("@/store/ducks/evaluators/selectors");
const removeEvaluatorUseCase_1 = __importDefault(require("@/useCases/evaluators/removeEvaluatorUseCase"));
const index_view_1 = __importDefault(require("./index.view"));
function RemoveAssociationDialog({ arrayHelpers }) {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isDialogVisible = (0, react_redux_1.useSelector)(selectors_1.isRemoveEvaluatorDialogOpenSelector);
    const evaluatorToBeDeleted = (0, react_redux_1.useSelector)(selectors_1.evaluatorToBeDeletedSelector);
    const systemOfEvaluatorToBeDeleted = (0, react_redux_1.useSelector)(selectors_1.systemOfEvaluatorToBeDeletedSelector);
    const rowIndexToBeDeleted = (0, react_redux_1.useSelector)(selectors_1.rowIndexToBeDeletedSelector);
    const onClose = react_1.default.useCallback(() => {
        dispatch((0, associatedComponents_1.closeDeleteAssociationModal)());
    }, [associatedComponents_1.closeDeleteAssociationModal]);
    const onProceed = react_1.default.useCallback(() => {
        arrayHelpers?.remove(rowIndexToBeDeleted);
        (0, removeEvaluatorUseCase_1.default)(evaluatorToBeDeleted?.id, systemOfEvaluatorToBeDeleted?.id)(dispatch);
    }, [evaluatorToBeDeleted, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { isOpen: isDialogVisible, onClose: onClose, onDismiss: onClose, systemName: systemOfEvaluatorToBeDeleted?.name, evaluatorNameToBeRemoved: evaluatorToBeDeleted?.username, onProceed: onProceed }));
}
exports.default = react_1.default.memo(RemoveAssociationDialog);
